import React from "react";
import {
  Button,
  Grid,
  Typography,
  Stack
} from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Modal from "../../Components/Modal";
import { sped } from "../../Requests";
import useGlobalContext from "../../Hooks/useGlobalContext";
import { useSnackbar } from "notistack";
import CompetenciaStorageUtils from "../../Storages/competenciaStorage";

interface IRemoveSpedProps {
  idSped: number;
  reloadResourceTable: () => void;
  close: () => void;
}

const RemoveSped: React.FC<IRemoveSpedProps> = ({
  idSped,
  reloadResourceTable,
  close
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoading, loading } = useGlobalContext();

  const handleCloseModal = () => close();

  const handleRemoveSped = async () => {
    if (!idSped) return;

    setLoading?.(true);

    const { data = "", status = 500, message = "" } = await sped.delete(`${idSped}`);

    setLoading?.(false);

    if (data || message) {
      const variant = status === 200 || status === 204 ? "success" : "error";
      enqueueSnackbar(message || "Erro ao remover SPED", { variant });
      
      // Limpa a competência selecionada do localStorage quando SPED é removido com sucesso
      if (status === 200 || status === 204) {
        CompetenciaStorageUtils.clear();
      }
    }

    reloadResourceTable();
    close();
  };

  return (
    <Modal
      title="Remover importação de Sped Fiscal"
      open={!loading}
      closeModal={handleCloseModal}
      maxWidth="sm"
    >
      <Grid container spacing={0.5}>
        <Grid item xs={12}>
          <Typography variant="body1">
            Tem certeza de que deseja remover esta importação de SPED Fiscal?
          </Typography>
          <Typography variant="body2" fontWeight="bold" color="error" mt={2}>
            Esta ação é irreversível!
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Stack direction="row" justifyContent="flex-end" spacing={2}>
            <Button variant="outlined" onClick={handleCloseModal} aria-label="Cancelar remoção">
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="error"
              startIcon={<DeleteForeverIcon />}
              onClick={handleRemoveSped}
              aria-label="Confirmar remoção de SPED"
            >
              Remover
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default RemoveSped;
